export class Setor {
    id?: number = -1;
    nome: string = "";
    sigla: string = "";
    cor: string = "";

    constructor();
    constructor(obj: Setor);
    constructor(obj?: Partial<Setor>) {
        Object.assign(this, obj);
    }
}